import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string'
import { LOAD_CABIN_CREW_ACTIVITY, GET_CABIN_CREW_ACTIVITY, CLEAR_CABIN_CREW_ACTIVITY } from "../types";
import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { CABIN_CREW_ACTIVITY_ENDPOINT } from '../../config/endpoints';

const loadCabinCrewActivity = (
  status
) => (dispatch) =>
    dispatch({
      type: LOAD_CABIN_CREW_ACTIVITY,
      payload: status,
    });

const getCabinCrewActivity = ({ cabinCrewId, fromDateString, toDateString }) => async (dispatch) => {
  try {
    dispatch(loadCabinCrewActivity(true));
    const url = `${CABIN_CREW_ACTIVITY_ENDPOINT}?${QueryString.stringify({ cabinCrewId, fromDateString, toDateString })}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const activity = await response.json();
    dispatch({
      type: GET_CABIN_CREW_ACTIVITY,
      payload: activity,
    });
  }
  catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(loadCabinCrewActivity(false));
  }
};

const clearCabinCrewActivity = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_ACTIVITY,
  });

const exportFile = async (formValues) => async (dispatch) => {
  try {
    dispatch(loadCabinCrewActivity(true));
    const url = `${CABIN_CREW_ACTIVITY_ENDPOINT}/export?${QueryString.stringify(
      formValues,
    )}`;
    const response = await fetch(url, {
      ...DEFAULT_GET_CONFIG,
    });
    await isErrorResponse(response, null, dispatch);
    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'Tareo.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(loadCabinCrewActivity(false));
  }
};

const getMonthlyCabinCrewActivity = ({ fromDateString, toDateString, cabinCrewStatusTypes, homeBaseLocationIds }) => async (dispatch) => {
  try {
    dispatch(loadCabinCrewActivity(true));
    const url = `${CABIN_CREW_ACTIVITY_ENDPOINT}?${QueryString.stringify({ fromDateString, toDateString, cabinCrewStatusTypes, homeBaseLocationIds })}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const activity = await response.json();
    dispatch({
      type: GET_CABIN_CREW_ACTIVITY,
      payload: activity,
    });
  }
  catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(loadCabinCrewActivity(false));
  }
}

export {
  getCabinCrewActivity,
  clearCabinCrewActivity,
  exportFile,
  getMonthlyCabinCrewActivity,
}